(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire0d69"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Sb6s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21793cc3e57d1f52$export$2e2bcd8739ae039; });
var $21793cc3e57d1f52$var$accordions = function() {
    $(".js-slider").on("init", function(event, slick, direction) {
        window.setTimeout(function() {
            $(".js-accordion-slider").hide();
        }, 200);
    });
    $(".js-accordion__header").click(function() {
        $(this).next().slideToggle(300, function() {
            window.dispatchEvent(new Event("resize"));
            $(".js-slider").slick("refresh");
        });
    });
};
var $21793cc3e57d1f52$export$2e2bcd8739ae039 = $21793cc3e57d1f52$var$accordions;

});

})();
//# sourceMappingURL=accordion.58dd93fe.js.map
